import { Accordion as FuseAccordion, AccordionProps as FuseAccordionProps } from "@tvg/fuse/accordion";
import React from "react";
import styles from "./Accordion.module.css";

export interface AccordionProps extends Omit<Partial<FuseAccordionProps>, "children"> {
  children: string;
}

const Accordion: React.FC<AccordionProps> = ({ children, ...props }: AccordionProps) => {
  return (
    <FuseAccordion
      chevronInline
      dataTestId="fuse-accordion-seo-accordion"
      headingTag="h1"
      hideBorder
      componentId="seo-accordion"
      titleSize={{ l: "large", m: "medium", s: "small", xl: "xlarge", xs: "xsmall", xxl: "xlarge", xxs: "xxsmall" }}
      {...props}
    >
      <span dangerouslySetInnerHTML={{ __html: children }} key="markupTorso" className={styles.accordion__content} />
    </FuseAccordion>
  );
};

export default React.memo(Accordion);
